'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of pre made template
 */ const PreMadeTemplate = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "19.9609",
                y: "31.625",
                width: "63.9459",
                height: "37.2432",
                rx: "3.47361",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                opacity: "0.7",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.9609 62.1157V65.3861C19.9609 67.3045 21.5161 68.8597 23.4345 68.8597H80.4333C82.3517 68.8597 83.9069 67.3045 83.9069 65.3861V62.1157H19.9609Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.1641",
                y: "68.8633",
                width: "19.6757",
                height: "6.04324",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.2812",
                y: "74.7676",
                width: "33.3081",
                height: "1.68649",
                rx: "0.843243",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "28",
                y: "41",
                width: "15",
                height: "13",
                rx: "0.72807",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "46",
                y: "41",
                width: "15",
                height: "13",
                rx: "0.72807",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "64",
                y: "41",
                width: "15",
                height: "13",
                rx: "0.72807",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("g", {
                clipPath: "url(#clip0_3459_3242)",
                children: /*#__PURE__*/ jsxRuntime.jsx("path", {
                    d: "M74.3143 45.1121C74.835 45.1121 75.2755 45.5432 75.2755 46.0645C75.2755 46.4255 75.0853 46.7363 74.8049 46.8967V48.561C74.8049 49.9446 73.6334 51.0575 72.1916 51.0575C70.7497 51.0575 69.6083 49.9847 69.5782 48.6312C68.4968 48.4106 67.6758 47.4582 67.6758 46.2951V43.9891C67.6758 43.8287 67.7959 43.6783 67.9561 43.6382L68.8973 43.4477C69.0876 43.4076 69.2678 43.538 69.3179 43.7285L69.3579 43.9691C69.398 44.1596 69.2678 44.3401 69.0776 44.3902L68.617 44.4804V46.2951C68.617 47.0972 69.2678 47.7389 70.0588 47.7188C70.8499 47.7188 71.4706 47.0671 71.4706 46.2751V44.4704L71.0201 44.3802C70.8298 44.3401 70.6896 44.1395 70.7397 43.949L70.7798 43.7285C70.8198 43.538 71 43.3976 71.2003 43.4477L72.1315 43.6382C72.2917 43.6683 72.4319 43.8187 72.4319 43.9791V46.2851C72.4319 47.4481 71.6108 48.4006 70.5294 48.6212C70.5595 49.4433 71.3004 50.095 72.1916 50.095C73.0827 50.095 73.8537 49.4132 73.8537 48.551V46.8867C73.5533 46.7263 73.3631 46.3954 73.3831 46.0345C73.3831 45.5332 73.8036 45.1121 74.3143 45.102V45.1121ZM74.3343 46.2951C74.4545 46.2951 74.5746 46.1949 74.5746 46.0545C74.5746 45.9342 74.4545 45.8139 74.3343 45.8139C74.2042 45.8139 74.094 45.9342 74.094 46.0545C74.094 46.1848 74.1941 46.2951 74.3343 46.2951Z",
                    fill: theme.ds5.asset[assetColor]["100"]
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx("g", {
                clipPath: "url(#clip1_3459_3242)",
                children: /*#__PURE__*/ jsxRuntime.jsx("path", {
                    d: "M50.0328 46.3009V45.3497H54.8644V50.5764C54.8644 50.8468 54.6406 51.047 54.3863 51.047H50.521C50.2464 51.047 50.0429 50.8367 50.0429 50.5764V49.6252H51.8535C51.9145 49.6252 51.9756 49.5851 51.9756 49.505V49.2647C51.9756 49.2046 51.9145 49.1446 51.8535 49.1446H50.0328V48.1933H51.8433C51.9044 48.1933 51.9654 48.1533 51.9654 48.0732V47.8329C51.9654 47.7728 51.9044 47.7127 51.8433 47.7127H50.0328V46.7615H51.8433C51.9044 46.7615 51.9654 46.7215 51.9654 46.6414V46.4011C51.9654 46.341 51.9044 46.2809 51.8433 46.2809H50.0328V46.3009ZM54.9864 43.4473C55.1797 43.4473 55.3526 43.6075 55.3526 43.8077V44.5186C55.3526 44.7289 55.1898 44.8791 54.9864 44.8791H49.9209C49.7073 44.8791 49.5547 44.7289 49.5547 44.5186V43.8077C49.5547 43.6175 49.7073 43.4473 49.9209 43.4473H54.9966H54.9864Z",
                    fill: theme.ds5.asset[assetColor]["100"]
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M35.0897 46.0374C35.2232 45.3103 35.6274 44.8004 35.8533 44.5669C35.9651 44.4517 35.9028 44.257 35.7449 44.2273C35.7362 44.2258 35.7271 44.2239 35.7179 44.2228C35.4559 44.1809 35.1939 44.3076 35.0483 44.5297C34.757 44.9742 34.7023 45.6077 34.7034 46.0298C34.2775 45.8157 33.2538 45.445 32.4845 46.339C31.4897 47.495 32.2313 49.9177 32.8876 50.6828C33.5196 51.4197 34.9042 50.8839 34.9042 50.8839C34.9042 50.8839 36.2883 51.4197 36.9207 50.6828C37.5775 49.9173 38.3186 47.4946 37.3238 46.339C36.545 45.4339 35.5058 45.8245 35.0897 46.0374Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M34.2273 45.555C34.3646 45.5896 34.4962 45.4832 34.4909 45.3413C34.4814 45.1021 34.4258 44.7439 34.2026 44.469C33.9794 44.194 33.6406 44.0655 33.4082 44.0066C33.2706 43.972 33.139 44.0784 33.1447 44.2203C33.1542 44.4595 33.2097 44.8177 33.433 45.093C33.6558 45.3679 33.995 45.4965 34.227 45.555H34.2273Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                        id: "clip0_3459_3242",
                        children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                            width: "7.60976",
                            height: "7.60976",
                            fill: "white",
                            transform: "translate(67.6758 43.4473)"
                        })
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                        id: "clip1_3459_3242",
                        children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                            width: "5.79791",
                            height: "7.60976",
                            fill: "white",
                            transform: "translate(49.5547 43.4473)"
                        })
                    })
                ]
            })
        ]
    });
};

exports.PreMadeTemplate = PreMadeTemplate;
//# sourceMappingURL=PreMadeTemplate.cjs.map
